<template>
    <div
        v-zindex="{channelName: 'dragable'}"
        class="draggable-wrapper hack-activex-container"
        :class="{'dragging': dragging}"
        :style="{left: `${x}px`, top: `${y}px`}"
        @mousedown="onDragStart"
        @dblclick="rePosition"
    >
        <div ref="centerShape" class="self-shape_center" />
        <iframe src="about:blank" class="hack-activex" />
        <div class="draggable-wrapper__background--head" />
        <div class="draggable-wrapper__background--left" />
        <!-- grip: 拖动🕹️-->
        <slot name="grip" />
        <slot />
    </div>
</template>

<script>
import isBoxCollide from 'library-@/utils/isBoxCollide';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import raf from 'raf';
import zindex from '../directives/zindex';

export default {
    directives: {
        zindex,
    },
    props: {
        initialX: {
            type: Number,
            default: 0,
        },
        initialY: {
            type: Number,
            default: 0,
        },
        movementBouncingEleSelector: {
            type: String,
            default: '',
        },
        mountPoint: {
            type: String,
            default: '',
        },
        minY: {
            type: Number,
        },
        reSet: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            x: -287,
            y: 90,
            startX: 0,
            startY: 0,
            startMouseX: 0,
            startMouseY: 0,
            dragging: false,
            onMove: () => {},
        };
    },
    computed: {
        gripEleSets() {
            const eleSet = new Set();
            const gripVnodes = get(this, '$slots.grip', []);
            gripVnodes.forEach(function(vnode) {
                if (vnode.elm) { eleSet.add(vnode.elm); }
            });
            return eleSet;
        },
    },
    methods: {
        onDragStart(e) {
            this.unbindEvents();
            const isForceDrag = e.ctrlKey || e.altKey;
            const isDraggingGrip = (() => {
                if (this.$slots.grip) {
                    if (this.gripEleSets.has(e.target)) {
                        return true;
                    }
                    return false;
                }
                return true;

            })();

            if (isForceDrag || isDraggingGrip) {
                e.preventDefault();
            } else {
                return;
            }

            e.stopPropagation();
            this.startX = this.x;
            this.startY = this.y;
            this.startMouseX = e.pageX;
            this.startMouseY = e.pageY;
            this.updateMovementBouncingElement();
            this.movementBouncingElement.addEventListener('mousemove', this.onMove);
            this.movementBouncingElement.addEventListener('mouseup', this.onDragStop);
            this.dragging = true;
        },
        updateMovementBouncingElement() {
            this.movementBouncingElement = this.movementBouncingEleSelector ? document.querySelector(this.movementBouncingEleSelector) : document.body;
        },
        unbindEvents() {
            this.movementBouncingElement.removeEventListener('mousemove', this.onMove);
            this.movementBouncingElement.removeEventListener('mouseup', this.onDragStop);
        },
        onDragStop() {
            this.dragging = false;
            this.unbindEvents();
            this.$emit('newPosition', [this.x, this.y]);
        },
        rePosition() {
            this.updateMovementBouncingElement();
            const bouncingRect = this.movementBouncingElement.getBoundingClientRect();
            const needBounceBack = !isBoxCollide(this.$refs.centerShape.getBoundingClientRect(), bouncingRect);
            if (needBounceBack) {
                const boxRect = this.$el.getBoundingClientRect();
                if (boxRect.x < 0) {
                    this.x = 0;
                } else if (boxRect.left + boxRect.width > bouncingRect.width) {
                    this.x = bouncingRect.width - boxRect.width;
                }
                if (boxRect.top + boxRect.height > bouncingRect.height) {
                    this.y = bouncingRect.height - boxRect.height;
                } else if (boxRect.y < bouncingRect.y) {
                    this.y = 0;
                }
            }
        },
        rePositionDebounced: debounce(function() {
            this.rePosition();
        }, 1000, {
            'leading': false,
            'trailing': true,
        }),
    },
    created() {
        this.updateMovementBouncingElement();
        this.x = isNumber(this.initialX) ? this.initialX : this.x;
        this.y = isNumber(this.initialY) ? this.initialY : this.y;
        this.onMove = e => {
            e.preventDefault();
            raf(() => {
                const offsetY = this.startY + e.pageY - this.startMouseY;

                this.x = this.startX + e.pageX - this.startMouseX;
                this.y = (isNumber(this.minY) && offsetY <= this.minY) ? this.minY : offsetY;
            });
        };
    },
    watch: {
        initialX(val) {
            if(!this.reSet) return;
            this.x = val;
        },
        initialY(val) {
            if(!this.reSet) return;
            this.y = val;
        },
    },
    mounted() {
        if (this.mountPoint) {
            let mountPointEle = document.querySelector(this.mountPoint);
            if (mountPointEle) {
                mountPointEle.appendChild(this.$el);
            }
        }
        window.addEventListener('resize', this.rePositionDebounced);
        this.$nextTick(() => {
            this.rePosition();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.rePositionDebounced);
        // 二次保险
        this.unbindEvents();
        if (this.mountPoint && get(this, '$el.parentNode.removeChild')) {
            this.$el.parentNode.removeChild(this.$el);
        }
    },
};


</script>

<style lang="scss">
.draggable-wrapper {
    position: absolute;
    z-index: 2000;
    .self-shape_center {
        position: absolute;
        top:50%;left:50%;width: 2px;height: 2px;
        user-select: none;z-index: 0;opacity: 0;
    }
    &__background--head {
        position: absolute;
        left: 0;
        top: 0;
        border: none;
        border-image: none;
        height: 35px;
        width: 100%;
        user-select: none;
    }
    &__background--left {
        position: absolute;
        left: 0;
        top: 0;
        border: none;
        border-image: none;
        height: 100%;
        width: 20px;
        user-select: none;
    }
}
</style>
